import AddOfferingForm from './AddOfferingForm';

import Page from '@/components/layout/Page';
import PageLoading from '@/components/layout/PageLoading';
import BackButton from '@/components/common/BackButton';
// import HorizontalLogo from '@/components/common/HorizontalLogo';

import { useQuery } from '@/helpers/useQuery';

import { useCoachActivity } from '@/data/coachActivity';
import { useOfferingCategories } from '@/data/offeringCategory';
import { useRegions } from '@/data/region';

const AddOfferingPage = () => {
  const backTo = useQuery('backTo');
  const coachActivityId = useQuery('coachActivityId');
  const coachActivity = useCoachActivity(coachActivityId);
  const offeringCategories = useOfferingCategories();
  const regions = useRegions();

  if (coachActivity.isLoading && !coachActivity.data) {
    return <PageLoading />;
  }
  if (offeringCategories.isLoading && !offeringCategories.data) {
    return <PageLoading />;
  }
  if (regions.isLoading && !regions.data) {
    return <PageLoading />;
  }

  return (
    <Page>
      <BackButton to={backTo} />
      <div className="p-6 text-center">
        <h1 className="text-3xl font-bold mb-4">Add Offering</h1>
      </div>
      <AddOfferingForm />
      <div className="flex justify-center py-8"></div>
    </Page>
  );
};

export default AddOfferingPage;
